<div class="modal-header bg-dark">
    <h4 class="modal-title">Completamento <strong>Pratica</strong></h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
        <i class="icons-office-52"></i>
    </button>
</div>
<div class="modal-body">
    <p>Confermi il completamento della pratica per l'azienda "{{ request.customer?.CompanyName }}"?</p>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default btn-blue btn-embossed" (click)="activeModal.close(request)">Conferma</button>
    <button type="button" class="btn btn-default btn-embossed" (click)="activeModal.close()">Chiudi</button>
</div>
